// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subMonths as fn } from "../subMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subMonthsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subMonthsWithOptions;
